module.exports = __webpack_public_path__ + "img/Little-Brown-Bat.0778924f.png";